import CreditMain from "../../components/credit-card-bill-payment-report/CreditMain"

export const CreditCardReport = ({ title_1, title_2, title }) => {
   
    return <div>
        <CreditMain title_1={title_1} title_2={title_2} title={title} />
    </div>
}